import React from 'react';
import { Box, Container, Text } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import Lottie from 'react-lottie';
import visualIntroduction from 'assets/images/common/visual-introduction.json';
import visualEducation from 'assets/images/common/visual-education.json';
import visualEvent from 'assets/images/common/visual-event.json';
import visualNotice from 'assets/images/common/visual-notice.json';
import visualPromotion from 'assets/images/common/visual-promotion.json';
import visualPrivacy from 'assets/images/common/visual-privacy.json';
import { selectDevice } from 'store/slices/common';

import './style.scss';

export default function Visual({ category, title }) {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  // 카테고리별 애니메이션 데이터 선택
  const getAnimationData = () => {
    switch (category) {
      case 'introduction':
        return visualIntroduction;
      case 'education':
        return visualEducation;
      case 'event':
        return visualEvent;
      case 'notice':
        return visualNotice;
      case 'promotion':
        return visualPromotion;
      case 'privacy':
        return visualPrivacy;
      default:
        return visualIntroduction; // 기본값
    }
  };

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: getAnimationData(),
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <section className={`visual ${category}`}>
      {isMobile ? (
        <Box>
          <Text as="p" className="subject title4">
            {title}
          </Text>
        </Box>
      ) : (
        <Container size="4">
          <h2 className="title3">{title}</h2>
          <div className="motion-container">
            <Lottie options={lottieOptions} height={220} isClickToPauseDisabled={true} />
          </div>
        </Container>
      )}
    </section>
  );
}
